module.exports = __webpack_public_path__ + "img/ico-replay-22.e26f9490.svg";